import EnumService from '../EnumService'

export default class TipoRegimeEnumService extends EnumService{

    constructor(){
        super('enumTipoRegime');
    }
  
  }